import { Navigate, useRoutes } from "react-router-dom";
import RequireAuth from "./components/RequireAuth";
import RequireGuest from "./components/RequireGuest";
import AppLayout from "./layouts/AppLayout";
import Home from "./pages/Home";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import MatchUpPage from "./pages/MatchUpPage";
import { Profile } from "./pages/Profile";

import Register from "./pages/Register";

// layouts

//

// Page routes

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: <RequireAuth />,
      children: [
        { path: "/", element: <Landing /> },
        { path: "/check-matches", element: <MatchUpPage /> },
        // { path: "/", element: <Navigate to="/home" replace /> },
      ],
    },
    {
      path: "/profile/:id",
      element: <RequireAuth />,
      children: [{ path: "/profile/:id", element: <Profile /> }],
    },
    {
      path: "/auth",
      element: <RequireGuest />,
      children: [
        { path: "/auth/login", element: <Login /> },
        {
          path: "/auth/register",
          element: <Register />,
        },
        {
          path: "/auth",
          element: <Navigate to="/auth/login" replace />,
        },
      ],
    },

    // {
    //   path: "/",
    //   element: <Home />,
    //   children: [
    //     { path: "/", element: <Navigate to="/dashboard/app" /> },
    //     // { path: '404', element: <Page.NotFound /> },
    //     { path: "*", element: <Navigate to="/404" /> },
    //   ],
    // },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);
}
